import moment from "moment-timezone";
import { isNil, get } from "lodash";
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
const READABLE_DATE_FORMAT = "Do MMMM";
const DAY_OF_WEEK_DAY_MONTH = "dddd D MMMM";
const DAY_OF_WEEK_DAY_MONTH_ORDINAL = "dddd Do MMMM";
const DAY_SHORT_MONTH_YEAR = "D MMM YYYY";
const DAY_MONTH_YEAR_TIME = "DD MMM YYYY HH:mm";
const DAY_MONTH_YEAR = "DD MMM YYYY";
const ESG_DATE_FORMAT = "YYYY-MM-DD";
const MONTH_DATE_FORMAT = "MMMM";
const DAY_OF_WEEK_DATE_FORMAT = "ddd";
const DAY_OF_WEEK = "dddd";
const TIME_FORMAT = "H:mm";
const FULL_MONTH_DATE_FORMAT = "MMMM D, YYYY";
const EUROPE_LONDON_TIME_ZONE = "Europe/London";
const DAY_OF_WEEK_DAY_MONTH_YEAR = "dddd D MMMM YYYY";

const format = (date, outputFormat, inputFormat) => moment(date, inputFormat).format(outputFormat);

export const getMilliseconds = date => {
  return moment(date).valueOf();
};
export const getMonthName = (date, inputFormat) => format(date, MONTH_DATE_FORMAT, inputFormat);
export const getDayNameShort = (date, inputFormat) => format(date, DAY_OF_WEEK_DATE_FORMAT, inputFormat);
export const getDate = date => moment(date).date();
export const getYear = date => moment(date).year();
export const formatDate = (dateAsString, outputFormat, inputFormat) => {
  const date = isNil(dateAsString) ? getCurrentDate() : dateAsString;
  return format(date, outputFormat, inputFormat);
};
export const formatDefaultDate = (dateAsString, inputFormat) => formatDate(dateAsString, DEFAULT_DATE_FORMAT, inputFormat);
export const formatDateTime = (dateAsString, inputFormat) => formatDate(dateAsString, DATE_TIME_FORMAT, inputFormat);
export const formatDayOfWeekDayMonth = (dateAsString, inputFormat) => formatDate(dateAsString, DAY_OF_WEEK_DAY_MONTH, inputFormat);
export const formatDayOfWeekDayMonthOrdinal = (dateAsString, inputFormat) => formatDate(dateAsString, DAY_OF_WEEK_DAY_MONTH_ORDINAL, inputFormat);
export const formatDayOfWeekDayMonthYear = (dateAsString, inputFormat) => formatDate(dateAsString, DAY_OF_WEEK_DAY_MONTH_YEAR, inputFormat);
export const formatDayShortMonthYear = (dateAsString, inputFormat) => formatDate(dateAsString, DAY_SHORT_MONTH_YEAR, inputFormat);
export const formatDayMonthYearTime = (dateAsString, inputFormat) => formatDate(dateAsString, DAY_MONTH_YEAR_TIME, inputFormat);
export const formatDayMonthYear = (dateAsString, inputFormat) => formatDate(dateAsString, DAY_MONTH_YEAR, inputFormat);
export const formatReadableDate = (dateAsString, inputFormat) => `${formatDate(dateAsString, DAY_OF_WEEK)} the ${formatDate(dateAsString, READABLE_DATE_FORMAT, inputFormat)}`;
export const formatESGDate = (dateAsString, inputFormat) => formatDate(dateAsString, ESG_DATE_FORMAT, inputFormat);
export const formatTime = date => format(date, TIME_FORMAT);
export const getUKCurrentMomentTime = () => moment().tz(EUROPE_LONDON_TIME_ZONE);
export const getCurrentDate = () => getUKCurrentMomentTime().toDate();
/**
 * @param {String | Number} dateAsString
 * @returns {String} date in format: "July 3, 2018
 */

export const formatDateWithFullMonthNameFirst = (dateAsString, inputFormat) => formatDate(dateAsString, FULL_MONTH_DATE_FORMAT, inputFormat);
export const getTodayMonthDayTime = () => formatDateWithFullMonthNameFirst(Date.now());
export const convertUkToIsoFormat = (ukDateString, inputFormat) => moment(ukDateString, DEFAULT_DATE_FORMAT).format(ESG_DATE_FORMAT, inputFormat);
/**
 * @returns {String} date like "2018-10-23T12:24:08"
 */

export const getCurrentDateTimeInDefaultFormat = () => getUKCurrentMomentTime().format(DEFAULT_DATE_TIME_FORMAT);
export const getCurrentDateTime = () => getUKCurrentMomentTime().format(DATE_TIME_FORMAT);
/**
 * @param {String} seconds - date like '55728'
 * @returns {String} date like "2018-10-23T12:24:08"
 */

export const formatInternalTime = seconds => {
  const time = moment().startOf("day").add(seconds, "s");
  return format(time, DEFAULT_DATE_TIME_FORMAT);
};
export const chooseSmallerDate = (date1, date2) => getMilliseconds(date1) > getMilliseconds(date2) ? date2 : date1;
export const calculatePositionInPeriod = (date, periodStart, periodEnd) => {
  const start = getMilliseconds(periodStart);
  const end = getMilliseconds(periodEnd);
  const value = getMilliseconds(date);
  return Math.round((value - start) / (end - start) * 100);
};
export const getArriveTime = (pickupLocationDriverWindow, estimatedDeliveryDate) => {
  return get(pickupLocationDriverWindow, `[${moment(estimatedDeliveryDate).day()}].endTime`);
};
export const formatAMPM = time => `After ${moment(time, "hh:mm").format("hh:mm a")}`;
export const fullDateValue = date => {
  const dateTime = moment(date);
  return {
    year: dateTime.year(),
    month: dateTime.format(MONTH_DATE_FORMAT),
    dayOfWeek: dateTime.format("dddd"),
    dayNumber: dateTime.date()
  };
};
export const getTimeArray = time => time && time.split(" - ");
export const isToday = date => moment(date).isSame(moment(), "day");
export const addDays = (date, days) => moment(date).add(days, "d");
export const getWeekDay = date => moment(date).day();
export const getHoursMinutes = time => {
  if (time < 60) {
    return `${time} minutes`;
  }

  const hours = ~~moment.duration(time, "minutes").asHours();
  const minutes = ~~moment.duration(time % 60, "minutes").asMinutes();
  return `${hours} hours ${minutes ? `${minutes} minutes` : ""}`;
};